import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';

/* import { update } from 'src/contexts/AuthProvider'; */

export const resetPassword = createAsyncThunk('auth/reset-password', async (data) => {
  await axios.post('/auth/reset_password/', data);
});

export const forgotPassword = createAsyncThunk('auth/forgot-password', async (email) => {
  const response = await axios.post('/auth/forgot_password/', email);
  return response.data;
});

export const getUsers = createAsyncThunk('get/users', async () => {
  const response = await axios.get('/user/');
  return response.data;
});

export const getUsersByGroup = createAsyncThunk('get/usersByGroup', async (usersGroup) => {
  const response = await axios.get('/user/get_user_by_group/', {
    params: {
      group: usersGroup,
    },
  });
  return response.data;
});

export const getUserById = createAsyncThunk('get/getUserById', async (userID, { rejectWithValue }) => {
  try {
    const response = await axios.get(`/user/${userID}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addUser = createAsyncThunk('add/users', async (user, { rejectWithValue }) => {
  try {
    const response = await axios.post('/user/', user);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateUser = createAsyncThunk(
  'update/updateUser',
  async ({ userID, userData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.put(`/user/${userID}/`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'update/updateUserProfile',
  async ({ userID, userData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.put(`/user/${userID}/`, userData);
      dispatch(getUserById(userID));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listUserGroup = createAsyncThunk('list/usergroup', async (params, { rejectWithValue }) => {
  try {
    const response = await axios.get(`/user/list_user_group/`, { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateUserPassword = createAsyncThunk(
  'update/user-password',
  async ({ userPasswordData }, { rejectWithValue }) => {
    try {
      const response = await axios.put('/user/update_password/', userPasswordData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUser = createAsyncThunk('delete/user', async (userID, { rejectWithValue }) => {
  try {
    const response = await axios.delete(`/user/${userID}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteManyUsers = createAsyncThunk('deleteMany/user', async (userIDs, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete('/user/delete_many/', {
      data: {
        arrId: userIDs,
      },
    });
    dispatch(getUsers());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getGroups = createAsyncThunk('get/groups', async () => {
  const response = await axios.get('/user/groups/');
  return response.data;
});

export const getClientHistory = createAsyncThunk(
  'charging-session/clientHistory',
  async (user_id, { rejectWithValue }) => {
    try {
      const response = await axios.get('/charging-session/client_history/', {
        params: {
          user_id: user_id,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const userAdapter = createEntityAdapter({});

const userSlice = createSlice({
  name: 'user',
  initialState: userAdapter.getInitialState({
    clientHistory: [],
    users: [],
    currentUser: '',
    groups: [],
    usersByGroup: [],
    userGroups: [],
    userById: null,
    userPasswordData: null,
    userEmail: null,
    loading: false,
    isSubmitting: false,
    updatedUserData: null,
    group: '',
  }),

  reducers: {
    setSearchText: (state, action) => {
      state.setSearchText = action.payload;
    },

    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },

    setGroup: (state, action) => {
      state.group = action.payload;
    },
    resetUserById: (state) => {
      state.userById = null;
    },

    resetUpdatedUserData(state) {
      state.updatedUserData = null;
    },
  },

  extraReducers: {
    [listUserGroup.pending]: (state) => {
      state.loading = true;
    },
    [listUserGroup.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.userGroups = data;
      state.loading = false;
    },
    [listUserGroup]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------
    [addUser.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addUser.fulfilled]: (state) => {
      userAdapter.addOne, (state.isSubmitting = false);
    },
    [addUser.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------
    [getUsers.pending]: (state) => {
      state.loading = true;
    },
    [getUsers.fulfilled]: (state, action) => {
      state.users = action.payload;
      state.loading = false;
    },
    [getUsers.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------
    [getGroups.pending]: (state) => {
      state.loading = true;
    },
    [getGroups.fulfilled]: (state, action) => {
      state.groups = action.payload.data;
      state.loading = false;
    },
    [getGroups.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------
    [getUserById.pending]: (state) => {
      state.loading = true;
    },
    [getUserById.fulfilled]: (state, action) => {
      state.userById = action.payload;
      state.loading = false;
    },
    [getUserById.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------
    [getUsersByGroup.pending]: (state) => {
      state.loading = true;
    },
    [getUsersByGroup.fulfilled]: (state, action) => {
      state.loading = false;
      state.usersByGroup = action.payload.data;
    },
    [getUsersByGroup.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------
    [getClientHistory.pending]: (state) => {
      state.loading = true;
    },
    [getClientHistory.fulfilled]: (state, action) => {
      state.loading = false;
      state.clientHistory = action.payload.data;
    },
    [getClientHistory.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------
    [deleteUser.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteUser.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteUser.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------

    [updateUser.pending]: (state) => {
      state.isSubmitting = true;
      state.loading = true;
    },

    [updateUser.fulfilled]: (state, action) => {
      state.userById = action.payload;
      state.isSubmitting = false;
    },

    [updateUser.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------

    [updateUserPassword.fulfilled]: (state, action) => {
      state.userPasswordData = action.payload;
      state.isSubmitting = false;
    },
    [updateUserPassword.rejected]: (state) => {
      state.isSubmitting = false;
    },
    [updateUserPassword.pending]: (state) => {
      state.isSubmitting = true;
    },
    // ---------------------------------------
    [deleteManyUsers.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyUsers.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyUsers.rejected]: (state) => {
      state.isSubmitting = false;
    },

    // ---------------------------------------
    [updateUserProfile.pending]: (state) => {
      state.isSubmitting = true;
    },

    [updateUserProfile.fulfilled]: (state, action) => {
      state.isSubmitting = false;
    },

    [updateUserProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },
  },
});

export const { setSearchText, setUserEmail, setGroup, resetUserById, resetUpdatedUserData } = userSlice.actions;

export default userSlice.reducer;
